app.service('sufficientOutletCategory', function () {
	return {
		init: () => { }
	};
});
